import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import PageTitle from "../../components/Commons/PageTitle";
import ServiceRequests from "../../components/Accounts/Account/ServiceRequests/ServiceRequests";
import SearchForm from "../../components/UI/SearchForm/SearchForm";


const Requests = () => {
    const {t} = useTranslation();

    return (
        < React.Fragment>
            <div className="container container--larger requests">
                <PageTitle title={t('requests.title')}/>
                <br/>
                <ServiceRequests />
            </div>
        </React.Fragment>
    )
};

export default Requests;
